import { render, staticRenderFns } from "./CommunicationItemText.vue?vue&type=template&id=75a9439c&scoped=true&"
import script from "./CommunicationItemText.vue?vue&type=script&lang=js&"
export * from "./CommunicationItemText.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationItemText.vue?vue&type=style&index=0&id=75a9439c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9439c",
  null
  
)

export default component.exports